import VLOCPaymentDetailsScreen from 'features/lineOfCredit/screens/paymentDetails/VLOCPaymentDetailsScreen';
import React from 'react';

export default function Page() {
  return <VLOCPaymentDetailsScreen />;
}
